import { accounting } from "common/utils";
import strings from "common/strings";

import { Presenter } from "common/components/table/cells/generic";

export class RatePresenter extends Presenter {
    itemContent = (column, content) => {
        if (Number.isNaN(content)) {
            return strings.nullRateTableCell;
        }
        
        if (Number.isFinite(content)) {
            return accounting.getRate({
                rate: content,
                humanize: true,
                precision: column.cellOptions.precision,
                addFloatValue: false
            });
        }
    
        return content.string;
    };
}
